import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { IUserStore } from '../../store/UserStore'
import { ILayoutStore } from '../../store/LayoutStore'
import { IWeekConsumptionStore } from '../../store/WeekConsumptionStore'
import ResultsGlobal from '../ResultsComponents/ResultsGlobal/ResultsGlobal'
import ResultsStatistics from '../ResultsComponents/ResultsStatistics/ResultsStatistics'
import ResultsRepeatTest from '../ResultsComponents/ResultsRepeatTest/ResultsRepeatTest'
import ResultsConsumption from '../ResultsComponents/ResultsConsumption/ResultsConsumption'
import ResultsCaloriesAndCash from '../ResultsComponents/ResultsCaloriesAndCash/ResultsCaloriesAndCash'
import { IResultStore } from '../../store/ResultStore'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import RiskCarrousel from '../ResultsComponents/ResultsRisks/RiskCarrousel'
import Share from '../Share/Share'
import { tag } from '../../services/ATInternetService'
import Title from '../Title/Title'
import ProgressBar from '../ProgressBar/ProgressBar'

interface IResultProps extends RouteComponentProps<any> {
  UserStore?: IUserStore
  WeekConsumptionStore?: IWeekConsumptionStore
  ResultStore: IResultStore
  LayoutStore: ILayoutStore
}

interface IResultState {
  resultsConsumptionIsVisible: boolean
  resultsCaloriesAndCashIsVisible: boolean
  resultsStatisticsIsVisible: boolean
  riskCarrouselIsVisible: boolean
  resultsRepeatTestIsVisible: boolean
}

@inject('UserStore', 'WeekConsumptionStore', 'ResultStore', 'LayoutStore')
@observer
class Results extends React.Component<IResultProps, IResultState> {
  private ResultsConsumptionRef = React.createRef<HTMLDivElement>()
  private ResultsCaloriesAndCashRef = React.createRef<HTMLDivElement>()
  private ResultsStatisticsRef = React.createRef<HTMLDivElement>()
  private RiskCarrouselRef = React.createRef<HTMLDivElement>()
  private ResultsRepeatTestRef = React.createRef<HTMLDivElement>()
  private ResultsConsumptionObserver: IntersectionObserver
  private ResultsCaloriesAndCashObserver: IntersectionObserver
  private ResultsStatisticsObserver: IntersectionObserver
  private RiskCarrouselObserver: IntersectionObserver
  private ResultsRepeatTestObserver: IntersectionObserver
  private MainTitleRef = React.createRef<HTMLDivElement>()

  public constructor(props: IResultProps) {
    super(props)
    this.state = {
      resultsConsumptionIsVisible: false,
      resultsCaloriesAndCashIsVisible: false,
      resultsStatisticsIsVisible: false,
      riskCarrouselIsVisible: false,
      resultsRepeatTestIsVisible: false,
    }
    // Set a flag in store in order to check if the user directly
    // wrote /results in the browser
    if (!this.props.UserStore.showResults) {
      this.props.history.push('/')
    }
  }

  public componentDidMount() {
    if (
      !this.ResultsConsumptionRef ||
      !this.ResultsCaloriesAndCashRef ||
      !this.ResultsStatisticsRef ||
      !this.RiskCarrouselRef ||
      !this.ResultsRepeatTestRef
    ) {
      return
    }

    this.ResultsConsumptionObserver = new IntersectionObserver(
      ([entry]) => this.setState({ resultsConsumptionIsVisible: entry.isIntersecting }),
      { rootMargin: '0px' }
    )

    this.ResultsCaloriesAndCashObserver = new IntersectionObserver(
      ([entry]) => this.setState({ resultsCaloriesAndCashIsVisible: entry.isIntersecting }),
      { rootMargin: '0px' }
    )

    this.ResultsStatisticsObserver = new IntersectionObserver(
      ([entry]) => this.setState({ resultsStatisticsIsVisible: entry.isIntersecting }),
      { rootMargin: '0px' }
    )

    this.RiskCarrouselObserver = new IntersectionObserver(
      ([entry]) => this.setState({ riskCarrouselIsVisible: entry.isIntersecting }),
      { rootMargin: '0px' }
    )

    this.ResultsRepeatTestObserver = new IntersectionObserver(
      ([entry]) => this.setState({ resultsRepeatTestIsVisible: entry.isIntersecting }),
      { rootMargin: '0px' }
    )

    this.ResultsConsumptionObserver.observe(this.ResultsConsumptionRef.current)
    this.ResultsCaloriesAndCashObserver.observe(this.ResultsCaloriesAndCashRef.current)
    this.ResultsStatisticsObserver.observe(this.ResultsStatisticsRef.current)
    this.RiskCarrouselObserver.observe(this.RiskCarrouselRef.current)
    this.ResultsRepeatTestObserver.observe(this.ResultsRepeatTestRef.current)
  }

  public componentWillUnmount() {
    this.ResultsConsumptionObserver.disconnect()
    this.ResultsCaloriesAndCashObserver.disconnect()
    this.ResultsStatisticsObserver.disconnect()
    this.RiskCarrouselObserver.disconnect()
    this.ResultsRepeatTestObserver.disconnect()
  }

  public render() {
    tag.sendPage({
      elem: this,
      name: 'Resultat',
      chapter1: 'Resultat',
    })

    return (
      <>
        <ProgressBar
          resultsConsumptionIsVisible={this.state.resultsConsumptionIsVisible}
          resultsCaloriesAndCashIsVisible={this.state.resultsCaloriesAndCashIsVisible}
          resultsStatisticsIsVisible={this.state.resultsStatisticsIsVisible}
          riskCarrouselIsVisible={this.state.riskCarrouselIsVisible}
          resultsRepeatTestIsVisible={this.state.resultsRepeatTestIsVisible}
        />
        <div className="Row-result Row-result--creame Row-result--brand" ref={this.MainTitleRef}>
          <Title>
            <p>Mon bilan</p>
            <p>personnalisé</p>
          </Title>
        </div>
        <div id="resultsconsumption" ref={this.ResultsConsumptionRef} className="Result-section">
          <div className="Row-result Row-result--creame50">
            <ResultsGlobal />
          </div>
          <div className="Row-result">
            <ResultsConsumption
              consumption={this.props.WeekConsumptionStore!.WeekConsumption.slice()}
              scrollIntoViewRef={this.ResultsConsumptionRef}
              // scrollIntoViewRef={this.MainTitleRef}
            />
          </div>
        </div>
        <div
          id="resultscaloriesandcash"
          ref={this.ResultsCaloriesAndCashRef}
          className="Result-section"
        >
          <div className="Row-result">
            <ResultsCaloriesAndCash
              calories={this.props.ResultStore.cal}
              cash={this.props.UserStore.price}
              showCalories={!this.props.ResultStore.isInConsumptionMarks}
            />
          </div>
        </div>
        <div id="resultsstatistics" ref={this.ResultsStatisticsRef} className="Result-section">
          <div className="Row-result">
            <Title subtitle={true}>
              <p>Pour me repérer</p>
            </Title>
            <ResultsStatistics />
          </div>
        </div>
        <div id="riskcarrousel" ref={this.RiskCarrouselRef} className="Result-section">
          <div className="Row-result">
            <RiskCarrousel />
          </div>
        </div>
        <div id="resultsrepeattest" ref={this.ResultsRepeatTestRef} className="Result-section">
          <Title subtitle={true}>
            <p>Pour aller plus loin</p>
          </Title>
          <div className="Row-result Row-result--creame">
            <ResultsRepeatTest />
          </div>
        </div>
        <div className="Row-result Row-result--creame">
          <Share />
        </div>
      </>
    )
  }
}

export default withRouter(Results)



// WEBPACK FOOTER //
// ./src/components/Results/Results.tsx